import WindowManager from './windowManagerRaw';
import { sendPostMessage, getParentWindow, check3pCookies } from '../../utils/browserUtils';
import postMessageTypes from '../../constants/messageTypes';
import store from '../../utils/store';


function setupWindowManagerOnMessage() {
  const windowManager = new WindowManager();

  async function interpretOnMessage(ev) {
    if (
      ev.source === getParentWindow(window)
    ) {
      if (ev.data.type === postMessageTypes.MANAGE_WINDOW) {
        const { argument: manageWindowArgument } = ev.data;
        await windowManager.open(manageWindowArgument);
        sendPostMessage({
          messageType: postMessageTypes.MANAGE_WINDOW_FINISHED,
          messageParams: {},
        });
      } else if (ev.data.type === postMessageTypes.CLOSE_ALL_WINDOW) {
        windowManager.closeAll();
        sendPostMessage({
          messageType: postMessageTypes.CLOSE_ALL_WINDOW_FINISHED,
          messageParams: {},
        });
      } else if (ev.data.type === postMessageTypes.UPDATE_GATEWAY_NAME) {
        const { gatewayName } = ev.data;
        window.updateGatewayName(gatewayName);
      }
    } else if (ev.data.type === 'SET_CROSS_SITE_COOKIE') {
      sendPostMessage({
        messageType: postMessageTypes.CONNECT_LOADED,
        messageParams: {
          thirdPartyCookieSupported: ev.data.hasAccess,
        },
      });
      windowManager._window.primary.close(false);
    }
  }

  function interpretFromNative(jsonData) {
    const data = JSON.parse(jsonData);
    if (data.type === postMessageTypes.MANAGE_WINDOW) {
      const { argument: manageWindowArgument } = data;
      windowManager.open(manageWindowArgument);
    }
  }

  switch (store.deviceType) {
    case 'web':
      window.addEventListener('message', interpretOnMessage);
      check3pCookies().then((thirdPartyCookieSupported) => {
        if (thirdPartyCookieSupported && typeof document.hasStorageAccess === 'function') {
          windowManager.open({
            primaryWindowType: 'iframe',
            primaryURL: 'https://cookie.smallca.se/check3p.html',
            silentIframe: true,
          });
        } else {
          sendPostMessage({
            messageType: postMessageTypes.CONNECT_LOADED,
            messageParams: {
              thirdPartyCookieSupported,
            },
          });
        }
      });
      break;

    case 'ios':
    case 'android':
      window.postToConnect = interpretFromNative;
      sendPostMessage({ messageType: postMessageTypes.CONNECT_LOADED });
      break;
    default:
      break;
  }
}

// eslint-disable-next-line import/prefer-default-export
export { setupWindowManagerOnMessage };



// WEBPACK FOOTER //
// ./logic/WindowManager/windowManager.js